import type { ErrorsTranslations } from './errors.translation.pl.ts';

export const errorsTranslations: ErrorsTranslations = {
  basic: {
    title: "Oups ! Quelque chose s'est mal passé",
  },
  inactive: {
    title: 'Oups ! Le lien a expiré.',
    subMessage: "Retourne à la page d'accueil et inscris-toi à nouveau.",
  },
  buttons: {
    back: 'Retour',
  },
};
